import React from 'react';

const SvgSelfRegistered: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="-4 -4 24 24" fill="none" {...props}>
    <path
      d="M6.5 7C8.15685 7 9.5 5.65685 9.5 4C9.5 2.34315 8.15685 1 6.5 1C4.84315 1 3.5 2.34315 3.5 4C3.5 5.65685 4.84315 7 6.5 7Z"
      fill="#373B40"
    />
    <path
      d="M6.763 8.50801C4.715 8.43301 0.5 9.45301 0.5 11.5V13H6.905C5.75 11.5 6.733 8.58201 6.763 8.50801ZM11.917
      10.083V8.75001H10.583V10.083H9.25V11.417H10.583V12.75H11.917V11.417H13.25V10.083H11.917Z"
      fill="#373B40"
    />
    <path
      d="M11.25 14.375C13.252 14.375 14.875 12.752 14.875 10.75C14.875 8.74797 13.252 7.125 11.25 7.125C9.24797 7.125 7.625
      8.74797 7.625 10.75C7.625 12.752 9.24797 14.375 11.25 14.375Z"
      stroke="#373B40"
      strokeWidth="0.75"
    />
  </svg>
);

export default SvgSelfRegistered;
